import { FC, useState } from 'react';

import MobileFeatureCard from 'components/Tables/FeatureComparisonTable/components/MobileFeatureCard';
import { FeatureComparisonTableConfigProps } from 'components/Tables/FeatureComparisonTable/config';
import { useScrollToAccordionItem } from 'components/Tables/FeatureComparisonTable/hooks/useScrollToAccordionItem';

type ColumnKey = 'columnOne' | 'columnTwo' | 'columnThree';

const MobileFeatureTable: FC<FeatureComparisonTableConfigProps> = ({
  columnOneTitle,
  columnOneIsPrismatic,
  columnTwoTitle,
  columnTwoIsPrismatic,
  columnThreeTitle,
  columnThreeHighlighted,
  columnThreeIsPrismatic,
  tableSections,
}) => {
  const [openColumn, setOpenColumn] = useState<ColumnKey | null>('columnThree');

  const scrollRefs = useScrollToAccordionItem(openColumn || '', 96);

  const handleToggle = (key: ColumnKey) => {
    setOpenColumn(prev => (prev === key ? null : key));
  };

  return (
    <div className="flex w-full flex-col lg:hidden">
      <div
        ref={el => {
          scrollRefs.current.columnThree = el;
        }}
      >
        <MobileFeatureCard
          title={columnThreeTitle}
          isHighlighted={columnThreeHighlighted}
          isPrismatic={columnThreeIsPrismatic}
          tableSections={tableSections}
          columnKey="columnThree"
          isOpen={openColumn === 'columnThree'}
          onToggle={() => handleToggle('columnThree')}
        />
      </div>

      <div
        ref={el => {
          scrollRefs.current.columnOne = el;
        }}
      >
        <MobileFeatureCard
          title={columnOneTitle}
          isHighlighted={false}
          isPrismatic={columnOneIsPrismatic && false}
          tableSections={tableSections}
          columnKey="columnOne"
          isOpen={openColumn === 'columnOne'}
          onToggle={() => handleToggle('columnOne')}
        />
      </div>

      <div
        ref={el => {
          scrollRefs.current.columnTwo = el;
        }}
      >
        <MobileFeatureCard
          title={columnTwoTitle}
          isHighlighted={false}
          isPrismatic={columnTwoIsPrismatic && false}
          tableSections={tableSections}
          columnKey="columnTwo"
          isOpen={openColumn === 'columnTwo'}
          onToggle={() => handleToggle('columnTwo')}
        />
      </div>
    </div>
  );
};

export default MobileFeatureTable;
